import React, { useRef, useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import BYDBanner from './Asset/byd-sealion-7.webp';
import BYDBannerMobile from './Asset/byd-sealion-7-1stBanner-Mobile.jpg';
import SealionExterior1 from './Asset/byd-sealion-7-exterior-01.jpg';
import SealionExterior2 from './Asset/byd-sealion-7-exterior-02.jpg';
import SealionInterior5 from './Asset/byd-sealion-7-interior-05.jpg';
import SealionInterior11 from './Asset/byd-sealion-7-interior-11.jpg';
import SealionCharging15 from './Asset/byd-sealion-7-charging-15.jpg';
import SealionPerformance16 from './Asset/byd-sealion-7-performance-16.jpg';
import Sealion25 from './Asset/byd-sealion-7-v2l-25.jpg';
import brochure from './Asset/SEALION-7-BROCHURE.pdf';
import { Helmet } from 'react-helmet-async';

function JelajahiSealion() {
  const sections = useRef([]);
  const [visibleSections, setVisibleSections] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const images = [
    {
      src: isMobile ? BYDBannerMobile : BYDBanner,
      title: 'BYD SEALION 7',
      specs: [
        { value: '23,000 RPM', label: 'Motor Speed' },
        { value: '215 km/h', label: 'Top Speed' },
        { value: 'Up to 91.3 kWh', label: 'Battery capacity' },
      ],
    },
    {
      src: SealionExterior1,
      title: 'Estetika Laut dengan Sentuhan Dinamis',
      description: `Dirancang oleh Direktur Desain Global BYD, Wolfgang Egger, BYD SEALION 7 bukan sekadar SUV—ini adalah pernyataan gaya hidup. Menggabungkan estetika yang terinspirasi oleh lautan dengan inovasi mutakhir, SUV ini diciptakan untuk mereka yang hidup dengan energi penuh. Garis-garisnya yang ramping dan mengalir, serta profil aerodinamisnya, memberikan tampilan sporty dan futuristik yang memikat perhatian di mana pun Anda berada. Jarak sumbu roda yang panjang tidak hanya meningkatkan kehadiran dinamis kendaraan ini tetapi juga memberikan interior yang luas dan nyaman, memadukan gaya dengan kepraktisan.`,
    },
    {
      src: SealionExterior2,
      description: `Gaya depan khas "OCEAN X" pada SEALION 7 menampilkan struktur X yang kokoh, memberikan kesan gagah dan berwibawa. Kap mesin yang rendah, desain fastback yang melengkung, serta garis pinggang ganda mencerminkan energi ombak laut, menciptakan siluet yang memadukan keanggunan dan performa.`,
    },
    {
      src: SealionInterior5,
      title: 'Mendefinisikan Ulang Indra dengan Tingkat Aspirasi Baru',
      description:
        'Terinspirasi oleh aliran dinamis dan kecepatan balap perahu layar, interior BYD SEALION 7 menghadirkan nuansa gerakan, suspensi, dan ruang. Desain ini menciptakan suasana yang kohesif dan imersif, di mana setiap elemen terasa melayang selaras dengan irama ombak.',
    },
    {
      src: SealionInterior11,
      title: 'Ruang untuk Menjalani Hidup Anda',
      description:
        'Dengan ruang 58 liter di bagian depan dan 520 liter di bagian belakang, yang dapat diperluas hingga 1.789 liter dengan melipat kursi belakang, SEALION 7 menawarkan fleksibilitas yang dibutuhkan untuk setiap petualangan. Sebagai gambaran, bagasi belakangnya dapat dengan nyaman memuat 1 koper besar berukuran 28 inci, 1 koper sedang berukuran 24 inci, dan 4 koper kabin berukuran 20 inci—sempurna untuk perjalanan keluarga atau liburan akhir pekan.',
    },
    {
      src: SealionCharging15,
      title: 'Pengisian Daya Cepat dan Efisien',
      description:
        'Tetap aktif dengan pengisian daya cepat DC hingga 230 kW. BYD SEALION 7 (varian Excellence AWD) dapat mengisi daya dari 10% hingga 80% hanya dalam 24 menit. Sempurna bagi mereka dengan jadwal padat, fitur ini memastikan Anda menghabiskan lebih sedikit waktu untuk menunggu dan lebih banyak waktu untuk menikmati hidup sepenuhnya.',
    },
    {
      src: SealionPerformance16,
      title: 'Performa, Berkendara dengan Tujuan',
      description:
        'Rasakan sensasi berkendara berperforma tinggi dengan motor listrik BYD SEALION 7 yang mencapai putaran mengesankan hingga 23.000 RPM. Varian AWD melaju dari 0-100 km/jam hanya dalam 4,5 detik. Dengan kecepatan maksimal 215 km/jam, SEALION 7 menjadi salah satu SUV terbaik, memadukan kekuatan, kecepatan, dan presisi untuk pengalaman berkendara yang mendebarkan.',
    },
    {
      src: Sealion25,
      title: 'V2L, Energi Sesuai Kebutuhan',
    },
  ];

  useEffect(() => {
    const currentSections = sections.current;

    const observer = new IntersectionObserver(
      (entries) => {
        setVisibleSections((prev) => {
          const updated = { ...prev };
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              updated[entry.target.dataset.index] = true;
            }
          });
          return updated;
        });
      },
      { threshold: 0.5 },
    );

    currentSections.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      currentSections.forEach((section) => {
        if (section) observer.unobserve(section);
      });
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>BYD Sealion 7 - Dealer Resmi di BSD Serpong</title>
        <meta
          name='description'
          content='Temukan BYD Sealion 7 di Dealer Resmi BYD BSD Serpong. Dapatkan promo terbaik untuk mobil listrik di lokasi Anda!'
        />
        <meta
          name='keywords'
          content='BYD Sealion 7 BSD Serpong, Dealer Mobil Listrik BSD Serpong, Harga BYD Sealion Serpong, BYD BSD Serpong'
        />
        <meta name='author' content='BYD BSD Serpong Junius' />
        <meta name='geo.region' content='ID-BT' />
        <meta
          name='geo.placename'
          content='BSD Serpong, Tangerang Selatan, Indonesia'
        />
        <meta name='geo.position' content='-6.3046;106.6496' />
        <meta name='ICBM' content='-6.3046, 106.6496' />
        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Product',
            name: 'BYD Sealion 7',
            image:
              'https://bydbsdserpong.com/static/media/byd-sealion-7.c510c808d64ebf63a56f.webp',
            description:
              'SUV listrik terbaru dengan performa tinggi, dirancang oleh Wolfgang Egger.',
            brand: {
              '@type': 'Brand',
              name: 'BYD',
            },
            offers: {
              '@type': 'Offer',
              price: 719000000,
              priceCurrency: 'IDR',
              availability: 'https://schema.org/InStock',
              url: 'https://bydbsdserpong.com',
            },
            mainEntity: [
              {
                '@type': 'Question',
                name: 'Apa keunggulan BYD Sealion 7 dibanding mobil listrik lain?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'BYD Sealion 7 unggul dalam performa, desain futuristik, pengisian cepat 230kW, dan teknologi V2L.',
                },
              },
              {
                '@type': 'Question',
                name: 'Dimana bisa beli BYD Sealion 7 di BSD Serpong?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Kunjungi dealer resmi BYD BSD Serpong atau hubungi melalui WhatsApp untuk info pemesanan dan test drive.',
                },
              },
            ],
          })}
        </script>
      </Helmet>
      <Typography
        variant='h1'
        component='h1'
        sx={{
          fontSize: { xs: '2rem', sm: '3rem' },
          textAlign: 'center',
          marginBottom: 4,
        }}
      >
        Jelajahi BYD Sealion 7
      </Typography>

      <Box>
        {images.map((img, index) => (
          <Box
            key={index}
            ref={(el) => (sections.current[index] = el)}
            data-index={index}
            sx={{
              position: 'relative',
              height: '100vh',
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
          >
            <Box
              component='img'
              src={img.src}
              alt={`${
                index === 0
                  ? 'BYD Sealion 7 - Banner menampilkan desain eksterior SUV listrik'
                  : img.title
                    ? `${img.title} - ${img.description || 'Fitur BYD Sealion 7'}`
                    : `BYD Sealion 7 - Gambar ${index + 1}`
              }`}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                zIndex: -1,
              }}
            />

            {img.title && (
              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '10%', sm: '15%' },
                  color: '#fff',
                  textAlign: 'center',
                  padding: 2,
                  transform: visibleSections[index]
                    ? 'translateY(0)'
                    : 'translateY(100%)',
                  opacity: visibleSections[index] ? 1 : 0,
                  transition: 'all 0.8s ease-in-out',
                }}
              >
                <Typography
                  variant='h4'
                  fontWeight='bold'
                  sx={{
                    fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                  }}
                >
                  {img.title}
                </Typography>
              </Box>
            )}

            {img.specs && (
              <Box
                sx={{
                  position: 'absolute',
                  bottom: { xs: '10%', sm: '5%' },
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  justifyContent: 'center',
                  gap: { xs: 2, sm: 4 },
                  color: '#fff',
                }}
              >
                {img.specs.map((spec, i) => (
                  <React.Fragment key={i}>
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography
                        variant='h6'
                        fontWeight='bold'
                        sx={{
                          fontSize: { xs: '1rem', sm: '1.25rem' },
                        }}
                      >
                        {spec.value}
                      </Typography>
                      <Typography
                        variant='body2'
                        sx={{
                          fontSize: { xs: '0.9rem', sm: '1rem' },
                        }}
                      >
                        {spec.label}
                      </Typography>
                    </Box>
                  </React.Fragment>
                ))}
              </Box>
            )}

            {img.description && (
              <Box
                sx={{
                  position: 'absolute',
                  bottom: { xs: '15%', sm: '10%' },
                  color: '#fff',
                  textAlign: 'center',
                  padding: 2,
                  maxWidth: { xs: '90%', sm: '80%' },
                  background: 'rgba(0, 0, 0, 0.5)',
                  borderRadius: '8px',
                  transform: visibleSections[index]
                    ? 'translateY(0)'
                    : 'translateY(100%)',
                  opacity: visibleSections[index] ? 1 : 0,
                  transition: 'all 0.8s ease-in-out',
                }}
              >
                <Typography
                  variant='body1'
                  fontWeight='400'
                  lineHeight='1.5'
                  sx={{
                    fontSize: { xs: '0.9rem', sm: '1rem' },
                  }}
                >
                  {img.description}
                </Typography>
              </Box>
            )}

            {img.src === Sealion25 && (
              <Button
                href={brochure}
                download='SEALION-7-BROCHURE.pdf'
                variant='outlined'
                sx={{
                  position: 'absolute',
                  bottom: '10%',
                  borderColor: '#fff',
                  color: '#fff',
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  fontWeight: 600,
                  padding: { xs: '8px 16px', sm: '10px 20px' },
                  '&:hover': {
                    backgroundColor: '#fff',
                    color: '#000',
                  },
                }}
              >
                Download Brosur
              </Button>
            )}
          </Box>
        ))}
        <Box sx={{ textAlign: 'center', mt: 8 }}>
          <Typography variant='h5' fontWeight='bold'>
            🚗 Tertarik dengan BYD Sealion 7?
          </Typography>
          <Typography variant='body1' mt={1}>
            Hubungi kami untuk jadwal test drive, harga terbaru, dan promo
            terbatas di BYD BSD Serpong!
          </Typography>
          <Button
            href='https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20tertarik%20dengan%20BYD%20Sealion%207'
            target='_blank'
            variant='contained'
            sx={{ mt: 2 }}
          >
            Hubungi via WhatsApp
          </Button>
        </Box>
        <br />
        <br />
      </Box>
    </>
  );
}

export default JelajahiSealion;
